import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@zola/zola-ui';

import OptionList from '../OptionList/OptionList';
import DetailColorPicker from '../DetailColorPicker/DetailColorPicker';
import FeatureFlags from '../../../../util/featureFlags';
import './OptionSection.less';

const OptionSection = ({
  title,
  options,
  selection,
  setOptionValue,
  currentLabel,
  currentDimension,
  sizePricing,
  optionType,
  isMagnet,
  isLinkHidden,
  titleLink,
  titleLinkAction,
}) => {
  function updateSelection(newSelection) {
    setOptionValue(newSelection);
  }

  const priceDelta = useMemo(() => {
    let result;
    if (sizePricing && optionType && selection.value) {
      if (optionType === 'size') {
        result = sizePricing.delta;
      } else {
        const optionPricing = sizePricing[optionType];
        result = optionPricing && optionPricing[selection.value];
      }
    }
    return result || 0;
  }, [sizePricing, optionType, selection.value]);

  return (
    <>
      <div className="option-section__title-area">
        <span>
          <span className="option-section__title">{title}:</span>
          <span className="option-section__sub-title">{currentLabel}</span>
          {currentDimension && optionType !== 'type' ? (
            <span className="option-section__dimensions">({currentDimension})</span>
          ) : null}
          {priceDelta && (FeatureFlags.get('invitesMagnetSilhouettePrice') || !isMagnet) ? (
            <span className="option-section__price">
              + ${(priceDelta / 100).toFixed(2).toString()} Ea.
            </span>
          ) : null}
        </span>
        {optionType === 'paper-type' && !isLinkHidden && (
          <span className="hidden-xs">
            <Link arrow role="button" className="option-section__link" onClick={titleLinkAction}>
              {titleLink}
            </Link>
          </span>
        )}
      </div>
      <div className="option-section__toggle-container">
        {title === 'Color' ? (
          <DetailColorPicker
            colors={options}
            activeColor={selection.value}
            onSelect={updateSelection}
          />
        ) : (
          <OptionList
            options={options}
            currentSelection={selection}
            onToggle={updateSelection}
            optionType={optionType}
            isMagnet={isMagnet}
            isLinkHidden={isLinkHidden}
            titleLink={titleLink}
            titleLinkAction={titleLinkAction}
          />
        )}
      </div>
    </>
  );
};

OptionSection.propTypes = {
  title: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
      subTitle: PropTypes.string,
    })
  ),
  selection: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  setOptionValue: PropTypes.func.isRequired,
  currentLabel: PropTypes.string,
  currentDimension: PropTypes.string,
  sizePricing: PropTypes.shape({}),
  optionType: PropTypes.string,
  isMagnet: PropTypes.bool,
  isLinkHidden: PropTypes.bool,
  titleLink: PropTypes.string,
  titleLinkAction: PropTypes.func,
};

export default OptionSection;



// WEBPACK FOOTER //
// ./src/cards/components/CardDetail/OptionSection/OptionSection.jsx